import {
  DELETE_WEBSITE_PRODUCT,
  LOAD_WEBSITE_PRODUCTS,
  LOAD_WEBSITE_PRODUCTS_FAIL,
  LOAD_WEBSITE_PRODUCTS_SUCCESS,
  LoadWebsiteProducts,
  LoadWebsiteProductsFail,
  LoadWebsiteProductsSuccess,
  UPDATE_WEBSITE_PRODUCT_STATE,
  UpdateWebsiteProductState,
  WebsiteProductAction
} from "../actions";
import {ProductType} from "../../websites/website/product";
import {Utils} from "../../shared/utils/utils";

export interface IWebsiteEntityProductState {
  websiteId: number;
  pluginEntities: {[slug: string]: any};
  extensionEntities: {[slug: string]: any};
  themeEntities: {[slug: string]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteProductState {
  entities: {[websiteId: number]: IWebsiteEntityProductState};
}

export const initialState: IWebsiteProductState = {
  entities: {}
};

export function reducer(state: IWebsiteProductState = initialState, action: WebsiteProductAction): IWebsiteProductState {
  let payload: any;

  switch (action.type) {

    case LOAD_WEBSITE_PRODUCTS:
      payload = (<LoadWebsiteProducts>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state.entities[payload],
            pluginEntities: {},
            extensionEntities: {},
            themeEntities: {},
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_WEBSITE_PRODUCTS_SUCCESS:
      payload = (<LoadWebsiteProductsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            pluginEntities: payload.pluginEntities,
            extensionEntities: payload.extensionEntities,
            themeEntities: payload.themeEntities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_WEBSITE_PRODUCTS_FAIL:
      payload = (<LoadWebsiteProductsFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case UPDATE_WEBSITE_PRODUCT_STATE:
      payload = (<UpdateWebsiteProductState>action).payload;

      if (!payload.product) {
        return state;
      }

      switch (payload.product.type) {
        case ProductType.PLUGIN:
          return {
            ...state,
            entities: {
              ...state.entities,
              [payload.websiteId]: {
                ...state.entities[payload.websiteId],
                pluginEntities: {
                  ...(state.entities[payload.websiteId] && state.entities[payload.websiteId].pluginEntities ? state.entities[payload.websiteId].pluginEntities : {}),
                  [payload.product.slug]: payload.product
                },
                loading: false,
                loaded: true
              }
            }
          };

        case ProductType.ADD_ON:
          return {
            ...state,
            entities: {
              ...state.entities,
              [payload.websiteId]: {
                ...state.entities[payload.websiteId],
                extensionEntities: {
                  ...state.entities[payload.websiteId].extensionEntities,
                  [payload.product.slug]: payload.product
                },
                loading: false,
                loaded: true
              }
            }
          };

        case ProductType.THEME:
          let websiteThemeEnetities: {[slug: string]: any} = state && state.entities[payload.websiteId] && state.entities[payload.websiteId].themeEntities || {};
          if (Utils.isTruthy(payload.product.active)) {
            websiteThemeEnetities = Object.values(websiteThemeEnetities).reduce((themeMap, theme) => {
              themeMap[theme.slug] = {
                ...theme,
                active: '0'
              };
              return themeMap;
            }, {});
          }
          websiteThemeEnetities = {
            ...websiteThemeEnetities,
            [payload.product.slug]: payload.product
          };

          return {
            ...state,
            entities: {
              ...state.entities,
              [payload.websiteId]: {
                ...state.entities[payload.websiteId],
                themeEntities: websiteThemeEnetities,
                loading: false,
                loaded: true
              }
            }
          };
      }

      return state;

    case DELETE_WEBSITE_PRODUCT:
      payload = (<UpdateWebsiteProductState>action).payload;

      if (!payload.product) {
        return state;
      }

      switch (payload.product.type) {
        case ProductType.PLUGIN:
          return {
            ...state,
            entities: {
              ...state.entities,
              [payload.websiteId]: {
                ...state.entities[payload.websiteId],
                pluginEntities: state && state.entities[payload.websiteId] ? Utils.removeEntityByKey(state.entities[payload.websiteId].pluginEntities, payload.product.slug) : {},
                loading: false,
                loaded: true
              }
            }
          };

        case ProductType.ADD_ON:
          return {
            ...state,
            entities: {
              ...state.entities,
              [payload.websiteId]: {
                ...state.entities[payload.websiteId],
                extensionEntities: state && state.entities[payload.websiteId] ? Utils.removeEntityByKey(state.entities[payload.websiteId].extensionEntities, payload.product.slug) : {},
                loading: false,
                loaded: true
              }
            }
          };

        case ProductType.THEME:
          return {
            ...state,
            entities: {
              ...state.entities,
              [payload.websiteId]: {
                ...state.entities[payload.websiteId],
                themeEntities: state && state.entities[payload.websiteId] ? Utils.removeEntityByKey(state.entities[payload.websiteId].themeEntities, payload.product.slug) : {},
                loading: false,
                loaded: true
              }
            }
          };
      }
  }

  return state;
}
